import { combineReducers } from "@reduxjs/toolkit";

import archiveReportCharts from "./charts";

const archiveReports = combineReducers({
	charts: archiveReportCharts,
});

export default archiveReports;
